import "antd/es/slider/style";
import _Slider from "antd/es/slider";
var _excluded = ["value", "$sui"],
    _excluded2 = ["rules", "format", "id", "verifyTriggers", "children", "onVerify", "labelId", "hideDefaultErrorMsg", "componentStyle", "help"];

var _class, _class2, _temp;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import { $attrs } from "../sui/bind";
import classnames from 'classnames';
import createFormComponent from '../sui/createFormComponent';
/**
 * 滑动输入控件
 */

var SuiSlider = createFormComponent(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(SuiSlider, _React$Component);

  var _super = _createSuper(SuiSlider);

  function SuiSlider(props, context) {
    var _this;

    _classCallCheck(this, SuiSlider);

    _this = _super.call(this, props);
    _this.defaultValue = undefined;

    _this.beforeVerify = function (trigger) {
      return false; // 不需要校验
    };

    _this.changeHandler = function (value) {
      _this.changeValue(value);
    };

    _this.getRefDOM = function (node) {
      if (node && _this.refDOM !== node) {
        _this.refDOM = node;
      }

      return _this.refDOM;
    };

    _this.getRefInstance = function (node) {
      if (node && _this.refInstance !== node) {
        _this.refInstance = node;
      }

      return _this.refInstance;
    };

    _this.onBlur = function (e) {
      _this.blurHandler(e);
    };

    _this.onFocus = function (e) {
      _this.focusHandler(e);
    };

    var _props$defaultValue = props.defaultValue,
        defaultValue = _props$defaultValue === void 0 ? 0 : _props$defaultValue;
    _this.attrs = $attrs({
      value: defaultValue,
      readOnly: false,
      disabled: false
    });

    _this.attrs.$sui.attach(props, _assertThisInitialized(_this), context);

    return _this;
  }

  _createClass(SuiSlider, [{
    key: "changeValue",
    value: // onChange修改value值
    function changeValue(val) {
      this.attrs.value = val;

      if (this.props.onChange) {
        this.props.onChange.call(this, val);
      }
    } // 获取组件容器DOM

  }, {
    key: "focus",
    value: function focus() {
      this.getRefInstance().focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.getRefInstance().blur();
    }
  }, {
    key: "doRender",
    value: function doRender() {
      console.log(" === render slider === ", this.attrs.value);

      var _this$attrs = this.attrs,
          value = _this$attrs.value,
          $sui = _this$attrs.$sui,
          attrs = _objectWithoutProperties(_this$attrs, _excluded);

      var _$sui$restProps = $sui.restProps,
          rules = _$sui$restProps.rules,
          format = _$sui$restProps.format,
          _$sui$restProps$id = _$sui$restProps.id,
          id = _$sui$restProps$id === void 0 ? this.uuid : _$sui$restProps$id,
          verifyTriggers = _$sui$restProps.verifyTriggers,
          children = _$sui$restProps.children,
          onVerify = _$sui$restProps.onVerify,
          labelId = _$sui$restProps.labelId,
          hideDefaultErrorMsg = _$sui$restProps.hideDefaultErrorMsg,
          componentStyle = _$sui$restProps.componentStyle,
          help = _$sui$restProps.help,
          props = _objectWithoutProperties(_$sui$restProps, _excluded2);

      var validated = this.verifyResult; // 值校验
      // let errorMsg;
      // if (validated.hasError && !hideDefaultErrorMsg) {
      //     errorMsg = this.getDefaultErrorMsg(validated.errorMsg);
      // }

      var classNames = classnames("sui-component sui-slider", {
        'has-error': validated.hasError,
        'sui-component-readonly': attrs.readOnly,
        'sui-component-disabled': attrs.disabled
      });

      if (!props.range) {
        if (typeof value !== "number") {
          value = 1 * value;
        }

        if (isNaN(value)) {
          value = 0;
        }
      } else {
        if (_typeof(value) !== "object") {
          value = [props.min, props.max];
        } else {
          value = _toConsumableArray(value);
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        style: componentStyle,
        id: id,
        ref: this.getRefDOM,
        className: classNames
      }, /*#__PURE__*/React.createElement(_Slider, _extends({
        id: labelId
      }, props, attrs, {
        value: value,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onChange: this.changeHandler,
        ref: this.getRefInstance
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return this.doRender();
    }
  }]);

  return SuiSlider;
}(React.Component), _class2.defaultProps = {
  max: 100,
  min: 0
}, _temp)) || _class;

export default SuiSlider;